// tslint:disable:no-any (autogenerated)
// tslint:disable:no-unsafe-any (autogenerated)
'use strict';
import Dispatcher from '../../components/base/dispatcher';
import loginRequests from './login-requests';
import settingsStore from '../../services/settings/settings-store';
import dialogsActions from '../dialogs/dialogs-actions';
import {
    IAcceptToSDialogData,
    tosDialogId
} from '../../components/customers/dit-pnp/pages/login/dialogs/accept-tos-dialog';
import { tosRequests } from '../tos/tos-requests';
import {
    IConfirmationEmailDialogData,
    emailConfiramtionDialogId
} from '../../components/customers/dit-pnp/pages/login/dialogs/email-confirmation-dialog';

// tslint:disable-next-line:typedef (autogenerated)
export function setLoginState(state) {
    Dispatcher.dispatch('setLoginState', state);
}

// tslint:disable-next-line:typedef (autogenerated)
export async function authorize(login: string, password: string, remember: boolean) {
    setLoginState({
        authorizing: true
    });

    try {
        const res: any = await loginRequests.authorize(login, password, remember);
        let shouldAcceptTos = false;
        let shouldResendConfirmationLink = false;

        /*************************************
****************************************************
********************************************************************
*********************************/

        if (shouldResendConfirmationLink) {
            dialogsActions.show<IConfirmationEmailDialogData>(emailConfiramtionDialogId);
            return;
        }

        if (shouldAcceptTos) {
            const tosText = await tosRequests.getTosText();
            dialogsActions.show<IAcceptToSDialogData>(tosDialogId, {
                data: {
                    tosText
                }
            });
        } else if (typeof window !== 'undefined' && res.redirectTo) {
            window.location.replace(res.redirectTo);
        }

        setLoginState({
            redirectTo: res.redirectTo,
            authorizing: false,
            authorized: res.success,
            authorizationError: !res.success
                ? res.errorMessage ||
                res.error ||
                res.message ||
                settingsStore.getIntlMessage('js.auth.pages.login.errors.general')
                : ''
        });

        return res;
    } catch (error) {
        console.log(error);
        setLoginState({
            authorizing: false,
            authorized: false,
            authorizationError:
                error.message || settingsStore.getIntlMessage('js.auth.pages.login.errors.general')
        });
        throw error;
    }
}

// tslint:disable-next-line:typedef (autogenerated)
function resetPasswords() {
    setLoginState({
        password: '',
        newPassword: '',
        confirmPassword: ''
    });
}

// tslint:disable-next-line:typedef (autogenerated)
export function setPage(page: string) {
    setLoginState({ page });
    resetPasswords();
}

export async function restorePassword(login: string, emailAsLogin: boolean = false): Promise<void> {
    setLoginState({
        restoringPassword: true
    });
    try {
        await loginRequests.restorePassword(login, emailAsLogin);
        resetPasswords();
        setLoginState({
            restoringPassword: false,
            restoringPasswordSuccess: true,
            restoringPasswordError: undefined
        });
    } catch (error) {
        resetPasswords();
        setLoginState({
            restoringPassword: false,
            restoringPasswordSuccess: false,
            restoringPasswordError: settingsStore
                .getIntlMessage('js.auth.pages.login.errors.restore-password')
                .replace('{error}', error.message || error)
        });
    }
}

// tslint:disable-next-line:typedef (autogenerated)
export async function resetPassword(login: string, token: string, password: string) {
    setLoginState({
        resettingPassword: true
    });
    try {
        await loginRequests.resetPassword(login, token, password);
        resetPasswords();
        setLoginState({
            resettingPassword: false,
            resettingPasswordSuccess: true,
            resettingPasswordError: undefined
        });
    } catch (error) {
        resetPasswords();
        setLoginState({
            resettingPassword: false,
            resettingPasswordSuccess: false,
            resettingPasswordError: settingsStore
                .getIntlMessage('js.auth.pages.login.errors.reset-password')
                .replace('{error}', error.message || error)
        });
    }
}

export async function validateResetPasswordToken(token: string, username: string): Promise<void> {
    try {
        setLoginState({
            validatingResetPasswordToken: true,
            resetPasswordTokenValid: undefined
        });
        const res = await loginRequests.validateResetPasswordToken(token, username);
        if (res.success) {
            setLoginState({
                validatingResetPasswordToken: false,
                resetPasswordTokenValid: true
            });
        } else {
            setLoginState({
                validatingResetPasswordToken: false,
                resetPasswordTokenValid: false
            });
        }
    } catch (e) {
        setLoginState({
            validatingResetPasswordToken: false,
            resetPasswordTokenValid: false
        });
        console.error('token validation error', e);
    }
}

// tslint:disable-next-line:typedef (autogenerated)
export async function registration(email: string, password: string, code: string) {
    setLoginState({
        registration: true
    });
    try {
        await loginRequests.registration(email, password, code);
        resetPasswords();
        setLoginState({
            registration: false,
            registrationSuccess: true,
            registrationError: undefined
        });
    } catch (error) {
        setLoginState({
            registration: false,
            registrationSuccess: false,
            registrationError: settingsStore
                .getIntlMessage('js.auth.pages.login.errors.registration')
                .replace('{error}', error.message || error)
        });
    }
}

// tslint:disable-next-line:typedef (autogenerated)
export async function activation(activationId: string) {
    setLoginState({
        activation: true
    });
    try {
        await loginRequests.activation(activationId);
        resetPasswords();
        setLoginState({
            activation: false,
            activationSuccess: true,
            activationError: undefined
        });
    } catch (error) {
        resetPasswords();
        setLoginState({
            activation: false,
            activationSuccess: false,
            activationError: settingsStore
                .getIntlMessage('js.auth.pages.login.errors.activation')
                .replace('{error}', error.message || error)
        });
    }
}
